import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  GET_SUBMITTED_CLAIM_REQUEST: '',
  GET_SUBMITTED_CLAIM_SUCCESS: '',
  GET_SUBMITTED_CLAIM_FAILURE: '',

  GET_CLAIM_SUBMISSION_FILE_REQUEST: '',
  GET_CLAIM_SUBMISSION_FILE_SUCCESS: '',
  GET_CLAIM_SUBMISSION_FILE_FAILURE: '',

  SEARCH_CLAIMS_REQUEST: '',
  SEARCH_CLAIMS_SUCCESS: '',
  SEARCH_CLAIMS_FAILURE: '',

  CREATE_CLAIM_REQUEST: '',
  CREATE_CLAIM_SUCCESS: '',
  CREATE_CLAIM_FAILURE: '',

  SAVE_CLAIM_REQUEST: '',
  SAVE_CLAIM_SUCCESS: '',
  SAVE_CLAIM_FAILURE: '',

  GET_EZ_CLAIM_REQUEST: '',
  GET_EZ_CLAIM_SUCCESS: '',
  GET_EZ_CLAIM_FAILURE: '',

  GET_EZ_CLAIM_STATUS_REQUEST: '',
  GET_EZ_CLAIM_STATUS_SUCCESS: '',
  GET_EZ_CLAIM_STATUS_FAILURE: '',

  CANCEL_CLAIM_REQUEST: '',
  CANCEL_CLAIM_SUCCESS: '',
  CANCEL_CLAIM_FAILURE: '',

  POST_CLAIM_HISTORY_REQUEST: '',
  POST_CLAIM_HISTORY_SUCCESS: '',
  POST_CLAIM_HISTORY_FAILURE: '',

  UPLOAD_CLAIM_ATTACHMENT_REQUEST: '',
  UPLOAD_CLAIM_ATTACHMENT_SUCCESS: '',
  UPLOAD_CLAIM_ATTACHMENT_FAILURE: '',

  GET_INVALID_PRIM_DX_INITIALS_REQUEST: '',
  GET_INVALID_PRIM_DX_INITIALS_SUCCESS: '',
  GET_INVALID_PRIM_DX_INITIALS_FAILURE: '',
};

types = setStoreTypeValues(types, 'claim');

export default types;
